import React, { FC } from 'react'
import styled from 'styled-components'

import { getProjectName } from '../../lib/get-project-name'
import { Icon } from '../icon'
import { EcomIconsId } from '../icon/types'

export type Props = {
  title?: string
  onClick?(): void
  active?: boolean
  iconName?: EcomIconsId
  customClass?: boolean
}

export const Tab: FC<Props> = ({ children, onClick, active, iconName, customClass }) => {
  return (
    <StyledTab onClick={onClick} active={active} customClass={customClass}>
      {children}
      {iconName && (
        <BackgroundIcon>
          <Icon name={iconName} size={1.5} />
        </BackgroundIcon>
      )}
    </StyledTab>
  )
}

const StyledTab = styled.button<{ active?: boolean; customClass?: boolean }>`
  padding: ${({ theme }) => `${theme.spacing[5]} ${theme.spacing[4]} ${theme.spacing[4]}`};
  padding: ${({ customClass }) => getProjectName() === 'haval' && customClass && '0 5px'};
  margin-bottom: ${({ active }) => (active ? '-1px' : '0')};
  color: ${({ theme, active }) => (active ? theme.palette.grey[900] : theme.palette.grey[500])};
  border: none;
  background: none;
  outline: none;
  cursor: pointer;
  transition: color 0.25s;
  ${({ theme }) => theme.textStyles.p2}
  font-weight: 700;
  white-space: nowrap;

  &:hover {
    color: ${({ theme }) => theme.palette.grey[900]};
  }
`

const BackgroundIcon = styled.div`
  padding: 5px;
  display: flex;
  background: white;
  align-items: center;
  border-radius: 50%;
`
